module.exports = __webpack_public_path__ + "img/shoukuan.fb1580c6.png";